<template>
  <b-form-group
    :label="title"
    label-class="mb-0 label-title"
    label-for="hours-form__item"
  >
    <b-row>
      <b-col cols="6">
        <b-form-select
          :class="{ saving: saving, saved: saved }"
          v-model="hoursValue"
          @change="onChange"
        >
          <option v-for="hour of options.hours" :key="hour" :value="hour">
            {{ hour }} hours
          </option>
          <option
            v-if="!options.hours.includes(hoursValue)"
            :value="hoursValue"
          >
            {{ hoursValue }} hours
          </option>
        </b-form-select>
      </b-col>
      <b-col cols="6">
        <b-form-select
          :class="{ saving: saving, saved: saved }"
          v-model="minutesValue"
          @change="onChange"
        >
          <option
            v-for="minute of options.minutes"
            :key="minute"
            :value="minute"
          >
            {{ minute }} minutes
          </option>
          <option
            v-if="!options.minutes.includes(minutesValue)"
            :value="minutesValue"
          >
            {{ minutesValue }} minutes
          </option>
        </b-form-select>
      </b-col>
    </b-row>
    <button
      class="activity-button"
      @click="item.type = 1"
      variant="default"
      size="sm"
    >
      This activity is more than 24 hours
    </button>
  </b-form-group>
</template>

<script>
import FormItem from "./FormItem";
import { debounce } from "lodash";
import { EventBus } from "../../event-bus";

export default {
  name: "HoursFormItem",
  components: {},
  props: {
    type: {
      required: false,
      default: "text",
    },
  },
  data: function () {
    return {
      options: {
        hours: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,
        ],
        minutes: [0, 15, 20, 25, 30, 35, 40, 45, 50, 55],
      },
      hoursValue: 0,
      minutesValue: 0,
      saving: false,
      saved: false,
      userHasInteracted: false,
    };
  },
  created() {
    // Create the debounced function once during component creation
    this.debouncedSave = debounce(() => {
      this.saved = true;
      this.saving = false;
      setTimeout(() => {
        this.saved = false;
      }, 1000);
    }, 1000);
  },
  watch: {
    hoursValue: function () {
      if (this.userHasInteracted) {
        this.updateValue();
      } else {
        // Update the item value without triggering auto-save during initial setup
        this.item.value = (
          this.hoursValue + this.twoDP(this.minutesValue / 60)
        ).toString();
      }
    },
    minutesValue: function () {
      if (this.userHasInteracted) {
        this.updateValue();
      } else {
        // Update the item value without triggering auto-save during initial setup
        this.item.value = (
          this.hoursValue + this.twoDP(this.minutesValue / 60)
        ).toString();
      }
    },
  },
  methods: {
    fieldState: function () {
      if (!this.item.required) {
        return undefined;
      }
      return this.item.value !== "";
    },
    updateValue: function () {
      this.item.value = (
        this.hoursValue + this.twoDP(this.minutesValue / 60)
      ).toString();
      this.saving = true;
      this.saved = false;
      EventBus.$emit("form-saving-started");
      this.debouncedSave();
    },
    onChange: function () {
      this.userHasInteracted = true;
      this.updateValue();
    },
    twoDP: function (num) {
      return Math.round(num * 100) / 100;
    },
    forceFreeText() {
      this.item.forceFreeText = true;
    },
  },
  computed: {
    title: function () {
      if (this.item.required) {
        return this.item.title + " *";
      }
      return this.item.title;
    },
  },
  mounted() {
    let itemValue = this.item.value;
    if (itemValue) {
      if (!isNaN(itemValue)) {
        let hours = Math.floor(itemValue);
        let minutes = Math.round((itemValue - hours) * 60);
        this.hoursValue = hours;
        this.minutesValue = minutes;
      } else {
        this.hoursValue = 0;
        this.minutesValue = 0;
      }
    }
  },
  extends: FormItem,
};
</script>

<style scoped lang="scss">
.activity-button {
  margin-top: 8px;

  outline: none;
  border: none;

  background-color: #fff;

  border-radius: 25px;
  box-shadow: 0px 1px 4px rgba(128, 128, 128, 0.4);
  border: 1px solid rgba(128, 128, 128, 0.4);

  padding: 0px 8px;
  font-size: 14px;
  font-weight: 500;
}
</style>
